export default __webpack_public_path__ + "static/media/readyforpickup-status.8d8e0ef5.svg";